import { initializeApp } from 'firebase/app';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Firebase configuration - completely fresh setup
const firebaseConfig = {
  apiKey: "AIzaSyCTOTH3RdkRxm_12ULm601t8aSAY_nCQvE",
  authDomain: "estonia-a5f02.firebaseapp.com",
  projectId: "estonia-a5f02",
  storageBucket: "estonia-a5f02.firebasestorage.app",
  messagingSenderId: "128891570229",
  appId: "1:128891570229:web:77e5362839d9c84bc4897c"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase Storage with explicit configuration
export const storage = getStorage(app, "gs://estonia-a5f02.firebasestorage.app");

// Initialize Firebase with comprehensive setup
export async function initializeFirebase() {
  try {
    console.log('🔥 Initializing Firebase from scratch...');
    console.log('Firebase config:', {
      projectId: firebaseConfig.projectId,
      storageBucket: firebaseConfig.storageBucket,
      authDomain: firebaseConfig.authDomain
    });

    // Test the storage connection
    const { ref, listAll } = await import('firebase/storage');
    const testRef = ref(storage, '');
    
    console.log('✅ Firebase Storage initialized successfully');
    console.log('Storage bucket:', storage.app.options.storageBucket);
    
    return true;
  } catch (error) {
    console.error('❌ Firebase initialization failed:', error);
    throw new Error(`Firebase initialization failed: ${error.message}`);
  }
}


